import { useGlitch } from 'react-powerglitch';
import { useEffect, useRef } from 'react';

export function Glitch({ disabled, children }: { children: React.ReactNode; disabled?: boolean }) {
  const glitch = useGlitch({
    playMode: 'manual',
    timing: {
      duration: Math.random() * 500 + 500,
    },
  });
  const glitchTimeoutRef = useRef<Timer>(null);

  useEffect(() => {
    const startGlitch = () => {
      glitchTimeoutRef.current = setTimeout(() => {
        glitch.startGlitch();
        startGlitch();
      }, Math.random() * 2000 + 2000);
    };

    const stopGlitch = () => {
      clearTimeout(glitchTimeoutRef.current!);
      glitch.stopGlitch();
    };

    if (disabled) {
      stopGlitch();
    } else {
      startGlitch();
    }

    const handleBeforeUnload = () => stopGlitch();
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      stopGlitch();
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [glitch, disabled]);

  return (
    <span ref={glitch.ref}>
      {children}
    </span>
  );
}